import CascadingAction from "@/action/CascadingAction"
import { applyService, sessionService } from "@/service"
import { applicationState, providerState, sessionState } from "@/state"
import { isAnyPreapprovalCode } from "@/model/apply/ApplyResponseCode"
import { getCalculatorCents } from "@/util/calculator"
import Providers from "@/model/provider/Providers"
import DynamicProviderKey from "@/model/provider/DynamicProviderKey";


class BasePreAuthAction extends CascadingAction {
    preauth = true

    async invoke() {
        sessionService.setMinTimeoutMillis(300000)

        const response = await this._submit()

        if (response.provider) {
            providerState.setPreAuthResponse(this.providerKey, response.provider)
            providerState.setStipulations(this.providerKey, response.provider.stipulations)
        }

        if (isAnyPreapprovalCode(response?.provider?.responseCode) && Providers[DynamicProviderKey.extractProviderKey(this.providerKey)].fetchPaymentPlansOnPreAuth) {
            const paymentPlansResponse = await applyService.getPaymentPlans(this.providerKey, {
                amountCents: getCalculatorCents(
                    response.provider.approvedAmountCents,
                    applicationState.application.purchaseAmountCents
                ),
            })

            providerState.setPaymentPlans(this.providerKey, paymentPlansResponse.paymentPlans)
        }

        return response
    }

    _submit() {
        throw new Error("Not Implemented")
    }
}

export default BasePreAuthAction
